import { formatRestrictionData } from '../../helpers/SiteSetupHelpers';
import { NotificationMessage } from 'Components/messages/ApiResultMessage';
import { createToast, toastType } from 'Common/ToastHelper';
import { loading } from 'State/actions';
import * as types from './types';

export const getChargeByStatus = siteId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SITESETUP_CHARGE_BY_STATUS_LOADING, true));

    try {
      let chargeResponse = await MPWWebApi.getGeneric(
        `poschargebystatus/${siteId}`
      );
      chargeResponse = formatRestrictionData(chargeResponse.data.Data);

      dispatch({
        type: types.SITESETUP_GET_CHARGE_BY_STATUS,
        payload: chargeResponse,
      });
    } catch (err) {}

    dispatch(loading(types.SITESETUP_CHARGE_BY_STATUS_LOADING, false));
  };
};

export const restrictionsEditGridLine = (status, newValue) => {
  return {
    type: types.SITESETUP_EDIT_GRID_LINE_CHARGE_BY_STATUS,
    payload: { status, newValue },
  };
};

export const setHasRestrictions = restrictionType => {
  return {
    type: types.SITESETUP_SET_RESTRICTIONS_CHARGE_BY_STATUS,
    payload: restrictionType,
  };
};

export const removeStudentRestrictions = (siteId, siteDescription) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      await MPWWebApi.postGenericInsertUpdate(
        `POSChargeByStatus/removeStudentChargeRestrictions`,
        `'${siteId}'`
      );

      createToast(
        toastType.success,
        'Success',
        'Student restrictions removed for ' + siteDescription,
        true
      );
    } catch (err) {
      NotificationMessage(err.response);
    }
  };
};

export const setNoRestriction = status => {
  return {
    type: types.SITESETUP_SET_NO_RESTRICTION_CHARGE_BY_STATUS,
    payload: status,
  };
};

export const clearChargeByStatus = () => {
  return {
    type: types.SITESETUP_CLEAR_CHARGE_BY_STATUS,
  };
};



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/chargeLimit/actions.js